//---------------------
// create markers parm
//---------------------
export default function createMarkersParm(props, selected_markers) {
  // console.log("---------------------");
  // console.log("IN createMarkersParm");
  // console.log("selected_markers = " + selected_markers);
  //-----------------
  // set update parm
  //-----------------
  let update_parm = {
    payload: {
      name: props.row["name"],
      slug: props.row["slug"],
      psyched: false,
      poisoned: false,
      constrained: false,
      special_marker: false,
      magicked_negatively: false,
      magicked_positively: false,
    },
    type: "markers",
  };
  //----------------------
  // loop thru selections
  //----------------------
  for (let i = 0; i < selected_markers.length; i++) {
    let marker = selected_markers[i];
    // console.log("i = " + " marker = " + marker);
    //--------------
    // check marker
    //--------------
    switch (marker) {
      case "poisoned":
        update_parm.payload.poisoned = true;
        break;
      case "constrained":
        update_parm.payload.constrained = true;
        break;
      case "psyched":
        update_parm.payload.psyched = true;
        break;
      case "special_marker":
        update_parm.payload.special_marker = true;
        break;
      case "magicked_negatively":
        update_parm.payload.magicked_negatively = true;
        break;
      case "magicked_positively":
        update_parm.payload.magicked_positively = true;
        break;
      default:
    }
  }
  return update_parm;
}
